import React from "react";
import "./index.css";

import {createSearchParams} from "react-router-dom";
import Sidebar from "../../../../components/Sidebar";
import TableHeader from "../../../../components/TableHeader/index";
import PageHeader from "../../../../components/PageHeader";
import moment from "moment";
import Pagination from "../../../../components/Pagination";
import LinkPlus from "../../../../components/Link/LinkPlus";
import {getSchoolYear} from "../../../../utils/authority";
import ClassRoomController from "../../../../services/data-declaration/class-room-controller";
import StudentController from "../../../../services/system/student/student-controller";
import vi from "date-fns/locale/vi";
import DatePicker, {registerLocale} from "react-datepicker";
import PublicSecureAuthorization from "../../../../services/system/secure-authorization/secure-authorization-controller";
import ModalDeleteInvoice from "./modalDeleteInvoice";
import PaymentServiceController from "../../../../services/system/payment-service/payment-service-controller";
import Utils from "../../../../utils/utils";
import GradeManager from "../../../../components/Grade";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import {toast} from "react-toastify";
import SchoolServiceController from "../../../../services/system/school-service/school-service-controller";
registerLocale("vi", vi);
const PaymentServiceType = {
    "SERVICE_BUS": "Xe bus",
    "SERVICE_CLB": "Câu lạc bộ",
    "SERVICE_EAT": "Ăn uống",
    "SERVICE_OTHER": "Dịch vụ khác",
    "LATE_PICK_UP": "Đón muộn",
    "FEE": "Học phí",
    "OTHER": "Khác",
}

class InvoiceManagement extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            startDate: null,
            endDate: null,
            listGroupUser: [],
            listData: [],
            listClass: [],
            pageNumber: 0,
            pageSize: 10,
            classRoomId: -1,

            listStudent: [],
            paymentServiceTypeState: "PARTIAL_PAYMENT",
            paymentType: "",
            listClassRoom: [],
            listServiceRegisteredByStudent: [],

            gender: "",
            code: "",
            ethnic: "",
            fullName: "",

            studentState: "",
            studentId: -1,
            serviceId: "",
            classId: "",
            gradeId: "",
            paymentServiceType: "",

            isShowText: false,
            sort: 'id',
            descending: 'DESC',
            totalItem: 0,
            headerMoney: [
                {
                    id: "123",
                    name: "",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "fee",
                    name: "Tổng",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "fee",
                    name: "Học phí",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "bus",
                    name: "Xe bus",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "clb",
                    name: "CLB",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "eat",
                    name: "Ăn sáng",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "other",
                    name: "Khác",
                    style: {textAlign: "center"},
                    sort: false
                },
            ],
            header: [
                {
                    id: "123",
                    name: "STT",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "title",
                    name: "Học sinh",
                    style: {textAlign: "left"},
                    sort: false
                },
                {
                    id: "title",
                    name: "Loại dịch vụ/Hàng hóa",
                    style: {textAlign: "left"},
                    sort: false
                },
                {
                    id: "total",
                    name: "Tên dịch vụ/Hàng hóa",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "pay",
                    name: "Phí dịch vụ/Hàng xóa(1)",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "tax",
                    name: "Thuế(2)",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "pay",
                    name: "Phụ phí(3)",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "paid",
                    name: "Đã đóng(4)",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "pay",
                    name: "Còn lại(1+2+3-4)",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "",
                    name: "Thao tác",
                    style: {minWidth: 120, textAlign: "center"},
                    sort: false
                }
            ]
        };
    }
    componentWillMount() {
        this.getListPayment()
        this.getListStudent()
        this.getListClass()
        this.getListGroupUser()
    }
    handleChangePage = page => {
        this.setState(
            {
                pageNumber: page
            },
            () => {
                this.getListStudent();
            }
        );
    };
    getListClass() {
        let payload = {
            yearId: parseInt(getSchoolYear()),
            grade: this.state.gradeId,
            name: "",
            pageNumber: 0,
            pageSize: 200,
            sort: "created_at desc"
        };
        ClassRoomController.search(payload, res => {
            this.setState({
                showLoading: false,
                listClass: res.data.content,
            });
        })
    }
    getListPayment() {
        let payload = {
            yearId: parseInt(getSchoolYear()),
            studentId: this.state.studentId,
            serviceId: this.state.serviceId,
            classId: this.state.classId,
            gradeId: this.state.gradeId,
            paymentServiceType: this.state.paymentServiceType,
            pageNumber: this.state.pageNumber,
            pageSize: this.state.pageSize,
            sort: "service_id desc"
        };
        PaymentServiceController.listPayment(payload, res => {
            this.setState({
                showLoading: false,
                listData: res.data.content,
                totalItem: res.data.totalElements,
                totalPage: Math.round(res.data.totalElements / this.state.pageSize)
            });
        })
    }
    onhandleSearch() {
        this.getListPayment();
    }
    onUpdateGrade(gradeId){
        this.setState({
            gradeId: gradeId
        }, ()=>{
            this.getListClass()
            this.onhandleSearch();
        });
    }
    renderClass() {
        return this.state.listClass.map((item, index) => <option
            value={item.id}>{item.name}</option>)
    }
    renderStatus() {
        let listStatus = [
            {
                "id": "PENDING",
                "name": "Chưa đóng phí"
            },
            {
                "id": "ACTIVE",
                "name": "Đã đóng phí"
            },
            {
                "id": "DISABLE",
                "name": "Đã đóng 1 phần"
            },
        ]
        return listStatus.map((item, index) => <option
            value={item.id}>{item.name}</option>)
    }
    renderNotiType() {
        let listState = [
            {
                "id": "SYSTEM",
                "name": "Hệ thống(Thông báo được gửi tự động từ hệ thống)"
            },
            {
                "id": "SCHOOL",
                "name": "Nhà trường(Được tạo từ nhà trường)"
            }
        ]
        return listState.map((item, index) => <option
            value={item.id}>{item.name}</option>)
    }
    getListGroupUser() {
        PublicSecureAuthorization.getListRoles(res => {
            if (res.success) {
                let data = res.data.content;
                this.setState(
                    {
                        listGroupUser: res.data.content
                    }
                );
            } else {
            }
        });
    }
    getPaymentService(paymentType){
        return PaymentServiceType[paymentType];
    }
    onUpdateGrade(gradeId){
        this.setState({
            gradeId: gradeId
        }, ()=>{
            if (gradeId === "")
                this.getAllClass()
            else {
                this.getListClass()
            }
        });
    }
    getListClass = () => {
        let payload = {
            name: "",
            grade: this.state.gradeId,
            yearId: parseInt(getSchoolYear()),
            pageNumber: 0,
            pageSize: 1000,
            "sort": "created_at desc"
        };
        ClassRoomController.search(payload, res => {
            this.setState({
                listClassRoom: res.data.content
            });
        })
    };

    getListStudent() {
        let payload = {
            yearId: parseInt(getSchoolYear()),
            classRoomId: this.state.classRoomId,
            grade: this.state.gradeId,
            fullName: this.state.studentName,
            code: "",
            ethnic: "",
            gender: "",
            pageNumber:0,
            pageSize: 100,
            sort: "created_at desc",
            studentState: "",
        };
        StudentController.search(payload, res => {
            this.setState({
                listStudent: res.data.content,
            });
        })
    }
    getListClass() {
        let payload = {
            yearId: parseInt(getSchoolYear()),
            grade: this.state.gradeId,
            name: "",
            pageNumber: 0,
            pageSize: 200,
            sort: "created_at desc"
        };
        ClassRoomController.search(payload, res => {
            this.setState({
                showLoading: false,
                listClassRoom: res.data.content,
            });
        })
    }
    renderClassRoom = () => {
        return this.state.listClassRoom.map((item, index) => <option
            value={item.id}>{item.name}</option>)
    };
    onUpdateGrade(gradeId){
        this.setState({
            gradeId: gradeId
        }, ()=>{
            this.getListClass()
        });
    }
    renderClass() {
        return this.state.listClassRoom.map((item, index) => <option
            value={item.id}>{item.name}</option>)
    }
    getAllClass = () => {
        let payload = {
            yearId: parseInt(getSchoolYear()),
            pageNumber: 0,
            pageSize: 1000,
            "sort": "created_at desc"
        };
        ClassRoomController.list(payload, res => {
            this.setState({
                showLoading: false,
                listClassRoom: res.data.content,
            });
        })
    };
    renderClassRoom = () => {
        return this.state.listClassRoom.map((item, index) => <option
            value={item.id}>{item.name}</option>)
    };
    renderService() {
        return this.state.listServiceRegisteredByStudent.map((item, index) => <option
            value={item.serviceRegisterId} service-id={item.serviceId} service-name={item.serviceName}  payment-service-type={item.paymentServiceType}>{item.serviceName}</option>)
    }

    render() {
        let {headerMoney, listData, header, gradeId} = this.state
        return (
            <div>
                <div className="container">
                    <div className="row">
                        <Sidebar activeClass="list-invoice" parentClass="wallet-management"/>
                        <div className="col-md-10 tab-content with-loading">
                            {this.state.showLoading &&
                            <div className="content-loading col-12 ml-3 align-items-center"
                                 style={{display: 'block'}}>
                                <div className="spinner-grow text-info"/>
                            </div>
                            }
                            <div className="card col-12">
                                <div className="pt-3 mb-2">
                                    <PageHeader routerEnable={true} title="Quản lý các khoản thu"/>
                                    <form className="mt-4 kt-form kt-form--fit kt-margin-b-20">
                                        <div className="row">
                                            <div className="col-xs-12 col-sm-12 col-md-6 p-1 pr-md-3 d-flex">
                                                <label className="col-md-4 label-item pl-0">Khối</label>
                                                <GradeManager
                                                    gradeId={gradeId}
                                                    onUpdateGrade={(gradeId) => this.onUpdateGrade(gradeId)}
                                                />
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 p-1 pr-md-3 d-flex">
                                                <label className="col-md-4 label-item pl-0">Lớp</label>
                                                <select
                                                    className="form-control kt-input pd-4-input hei-input"
                                                    value={this.state.classRoomId}
                                                    onChange={(e) => {
                                                        this.state.classRoomId = e.target.value;
                                                        this.setState({
                                                            classRoomId: e.target.value,
                                                            inEditing: true
                                                        }, () =>{
                                                            this.getListStudent()
                                                            this.onhandleSearch();
                                                        })
                                                    }}
                                                >
                                                    <option value="-1">Chọn lớp</option>
                                                    {this.renderClassRoom()}
                                                </select>
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 p-1 pr-md-3 d-flex">
                                                <label className="col-md-4 label-item pl-0">Chọn học sinh</label>
                                                <Autocomplete
                                                    size="small"
                                                    options={this.state.listStudent}
                                                    getOptionLabel={option => option.fullName?option.fullName:""}
                                                    style={{width: '100%'}}
                                                    inputValue={this.state.studentName}
                                                    renderInput={params => {
                                                        return <TextField
                                                            placeholder='Nhập tên học sinh'
                                                            {...params}
                                                            InputLabelProps={{
                                                                shrink: true,
                                                                style: {
                                                                    fontSize: 17,
                                                                    backgroundColor: "#FFF",
                                                                    paddingRight: 10,
                                                                    paddingLeft: 10,
                                                                    color: '#2e495c',
                                                                    fontWeight: 500,
                                                                    fontFamily: 'Montserrat'
                                                                }
                                                            }}
                                                            label=""
                                                            variant="outlined"
                                                            fullWidth
                                                        />
                                                    }}
                                                    onInputChange={(event, val) => {
                                                        if (event !== null){
                                                            this.setState({
                                                                studentName: val
                                                            })
                                                            if (val === ""){
                                                                this.state.studentId = -1;
                                                            }
                                                        }
                                                    }}
                                                    onChange={(e, val) => {
                                                        if (val?.id != undefined){
                                                            this.setState({
                                                                studentId: val?.id,
                                                                studentName: val?.fullName,
                                                            }, ()=>{
                                                                this.onhandleSearch();
                                                            })
                                                        }else {
                                                            this.setState({
                                                                studentId: -1,
                                                                studentName: "",
                                                            })
                                                        }
                                                        // this.getListPeopleInCharge()
                                                    }}

                                                />
                                            </div>
                                            {/*<div className="col-xs-12 col-sm-12 col-md-6 p-1 pr-md-3 d-flex">*/}
                                            {/*    <label className="col-md-4 label-item pl-0">Loại thanh toán</label>*/}
                                            {/*    <select*/}
                                            {/*        className="form-control kt-input pd-4-input hei-input"*/}
                                            {/*        value={this.state.paymentType}*/}
                                            {/*        onChange={(e) => {*/}
                                            {/*            this.state.paymentType = e.target.value;*/}
                                            {/*            this.setState({*/}
                                            {/*                paymentType: e.target.value*/}
                                            {/*            })*/}
                                            {/*        }}*/}
                                            {/*    >*/}
                                            {/*        <option value="">Tất cả</option>*/}
                                            {/*        <option value="NHAN_TIEN">Nhận tiền</option>*/}
                                            {/*        <option value="TRA_TIEN">Trả tiền</option>*/}
                                            {/*    </select>*/}
                                            {/*</div>*/}
                                            <div className="col-xs-12 col-sm-12 col-md-6 p-1 pr-md-3 d-flex">
                                                <label className="col-md-4 label-item pl-0">Loại dịch vụ</label>
                                                <select
                                                    className="form-control kt-input pd-4-input hei-input"
                                                    value={this.state.paymentServiceType}
                                                    onChange={(e) => {
                                                        this.state.paymentServiceType = e.target.value;
                                                        this.setState({
                                                            paymentServiceType: e.target.value
                                                        }, ()=>{
                                                            this.onhandleSearch();
                                                        })
                                                    }}
                                                >
                                                    <option value="">Chọn loại dịch vụ</option>
                                                    <option value="SERVICE_BUS">Xe bus</option>
                                                    <option value="SERVICE_CLB">Câu lạc bộ</option>
                                                    <option value="SERVICE_EAT">Ăn uống</option>
                                                    <option value="SERVICE_OTHER">Dịch vụ khác</option>
                                                    <option value="LATE_PICK_UP">Đón muộn</option>
                                                    <option value="FEE">Học phí</option>
                                                    <option value="OTHER">Khác</option>
                                                </select>
                                            </div>
                                            {/*<div className="col-xs-12 col-sm-12 col-md-6 p-1 pr-md-3 d-flex">*/}
                                            {/*    <label className="col-md-4 label-item pl-0">Chọn dịch vụ thanh toán</label>*/}
                                            {/*    <select*/}
                                            {/*        className="form-control kt-input pd-4-input hei-input"*/}
                                            {/*        value={this.state.serviceId}*/}
                                            {/*        onChange={(e) => {*/}
                                            {/*            let index = e.target.selectedIndex;*/}
                                            {/*            let optionElement = e.target.childNodes[index]*/}
                                            {/*            let serviceName =  optionElement.getAttribute('service-name')*/}
                                            {/*            let paymentServiceType =  optionElement.getAttribute('payment-service-type')*/}
                                            {/*            let serviceId = e.target.value;*/}
                                            {/*            this.setState({*/}
                                            {/*                serviceId: serviceId,*/}
                                            {/*                paymentServiceType: paymentServiceType,*/}
                                            {/*                serviceName: serviceName,*/}
                                            {/*            },()=>{*/}
                                            {/*                this.getListPayment();*/}
                                            {/*            })*/}
                                            {/*        }}*/}
                                            {/*    >*/}
                                            {/*        <option value="" service-name="" payment-service-type ="">Chọn dịch vụ đã đăng ký</option>*/}
                                            {/*        {this.renderService()}*/}
                                            {/*    </select>*/}
                                            {/*</div>*/}
                                            <div className="col-xs-12 col-sm-12 col-md-12 p-1 pr-md-3 d-flex" style={{
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center"
                                            }}>
                                                <button
                                                    style={{height: 35}}
                                                    type="button"
                                                    className="border-1-s background-btn type-button-fix btn btn-primary btn-sm"
                                                    onClick={() => this.onhandleSearch()}
                                                >
                                                    Tìm kiếm
                                                </button>
                                            </div>
                                            <div className="col-12 d-flex row mt-2">
                                                <table
                                                    className="table table-striped table-data table-responsive table-bordered">
                                                    <table className="table">
                                                        <thead>
                                                        <TableHeader
                                                            header={headerMoney}
                                                        />
                                                        </thead>
                                                        <tbody>
                                                        <tr style={{height: 50}}>
                                                            <td style={{textAlign: "center"}} scope="row">
                                                                Tổng tiền
                                                            </td>
                                                            <td style={{textAlign: "left"}} scope="row">
                                                            </td>
                                                            <td style={{textAlign: "left"}} scope="row">
                                                            </td>
                                                            <td style={{textAlign: "center"}}>
                                                            </td>
                                                            <td style={{textAlign: "left"}}>
                                                            </td>
                                                            <td style={{textAlign: "left"}}>
                                                            </td>
                                                            <td style={{textAlign: "left"}}>
                                                            </td>
                                                        </tr>
                                                        <tr style={{height: 50}}>
                                                            <td style={{textAlign: "center"}} scope="row">
                                                                Đã thu
                                                            </td>
                                                            <td style={{textAlign: "left"}} scope="row">
                                                            </td>
                                                            <td style={{textAlign: "left"}} scope="row">
                                                            </td>
                                                            <td style={{textAlign: "center"}}>
                                                            </td>
                                                            <td style={{textAlign: "left"}}>
                                                            </td>
                                                            <td style={{textAlign: "left"}}>
                                                            </td>
                                                            <td style={{textAlign: "left"}}>
                                                            </td>
                                                        </tr>
                                                        <tr style={{height: 50}}>
                                                            <td style={{textAlign: "center"}} scope="row">
                                                                Còn lại
                                                            </td>
                                                            <td style={{textAlign: "left"}} scope="row">
                                                            </td>
                                                            <td style={{textAlign: "left"}} scope="row">
                                                            </td>
                                                            <td style={{textAlign: "center"}}>
                                                            </td>
                                                            <td style={{textAlign: "left"}}>
                                                            </td>
                                                            <td style={{textAlign: "left"}}>
                                                            </td>
                                                            <td style={{textAlign: "left"}}>
                                                            </td>
                                                        </tr>
                                                        </tbody>
                                                    </table>
                                                </table>
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-12 p-0 pr-md-3 d-flex mt-3"
                                                 style={{
                                                     alignItems: "center",
                                                     justifyContent: "right"
                                                 }}>
                                                <LinkPlus
                                                    style={{color: '#000'}}
                                                    to={{
                                                        pathname: "/ad-sas-school/them-khoan-thu-chi",
                                                        state: {
                                                            fromDashboard: true,
                                                        }
                                                    }}
                                                >
                                                    <button
                                                        style={{height: 35, marginRight: 12}}
                                                        type="button"
                                                        className="border-1-s background-btn type-button-fix btn btn-primary btn-sm"
                                                    >
                                                        Thêm mới
                                                    </button>
                                                </LinkPlus>

                                                {/*<button*/}
                                                {/*    style={{height: 35, marginRight: 12}}*/}
                                                {/*    type="button"*/}
                                                {/*    className="border-1-s background-btn type-button-fix btn btn-primary btn-sm"*/}
                                                {/*    onClick={() => this.setState({showModalCreate: true})}*/}
                                                {/*>*/}
                                                {/*    Xuất Excell*/}
                                                {/*</button>*/}
                                            </div>
                                        </div>
                                    </form>
                                </div>
                                <div className="p-0 mb-3">
                                    <div className="table-wrapper">
                                        <table
                                            className="table table-striped table-data table-responsive table-bordered">
                                            <table className="table">
                                                <thead>
                                                <TableHeader
                                                    header={header}
                                                    clickSort={data => {
                                                    }}
                                                />
                                                </thead>
                                                {!this.state.listData ||
                                                this.state.listData.length == 0 ? (
                                                    <tbody>
                                                    <tr>
                                                        <td colSpan={12}>
                                                            <div className="text-center">
                                                                Không có dữ liệu
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    </tbody>
                                                ) : (
                                                    <tbody>
                                                    {listData &&
                                                    listData.length > 0 &&
                                                    listData?.map((row, index) => (
                                                        <tr style={{height: 50}}>
                                                            <td style={{textAlign: "center"}} scope="row">
                                                                {" "}
                                                                {this.state.pageNumber * this.state.pageSize +
                                                                index +
                                                                1}
                                                            </td>
                                                            <td style={{textAlign: "left"}} scope="row">
                                                                {row.studentLiteRes?.fullName}
                                                            </td>
                                                            <td style={{textAlign: "left"}} scope="row">
                                                                {this.getPaymentService(row.paymentServiceType)}
                                                            </td>
                                                            <td style={{textAlign: "left"}} scope="row">
                                                                {row.serviceName}
                                                            </td>
                                                            <td style={{textAlign: "center"}}>
                                                                {Utils.formatMoney(row.price)} VNĐ
                                                            </td>

                                                            <td style={{textAlign: "left"}}>
                                                                {Utils.formatMoney(row.tax)} VNĐ
                                                            </td>
                                                            <td style={{textAlign: "left"}}>
                                                                {Utils.formatMoney(row.surcharge)} VNĐ
                                                            </td>
                                                            <td style={{textAlign: "left"}}>
                                                                {Utils.formatMoney(row.totalPayment)} VNĐ
                                                            </td>
                                                            <td style={{textAlign: "left"}}>
                                                                {Utils.formatMoney(parseFloat(row.price)+parseFloat(row.tax)+parseFloat(row.surcharge)-parseFloat(row.totalPayment))} VNĐ
                                                            </td>
                                                            <td style={{textAlign: "center"}}>
                                                                <LinkPlus
                                                                    style={{color: '#000'}}
                                                                    to={{
                                                                        pathname: "/ad-sas-school/chi-tiet-cac-khoan-thu-chi",
                                                                        search: createSearchParams({
                                                                            studentId: `${row.studentLiteRes?.id}`
                                                                        }).toString(),
                                                                        state: {
                                                                            fromDashboard: true,
                                                                            studentId: row.studentLiteRes?.id
                                                                        }
                                                                    }}
                                                                >
                                                                    <button className="btn btn-action p-2"
                                                                            title='Sửa'
                                                                            style={{cursor: 'pointer'}}
                                                                    >
                                                                        <i className="ti-pencil-alt"/>
                                                                    </button>
                                                                </LinkPlus>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                    </tbody>
                                                )}
                                            </table>
                                        </table>
                                    </div>
                                    <div className="pagination-right">
                                        <Pagination
                                            activePage={this.state.pageNumber}
                                            itemsCountPerPage={this.state.pageSize}
                                            totalItemsCount={this.state.totalItem}
                                            changeHandler={page => this.handleChangePage(page)}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <ModalDeleteInvoice
                    show={this.state.showModalDelete}
                    onHide={() => this.setState({showModalDelete: false})}
                    onRefresh={() => this.onhandleSearch()}
                    id={this.state.itemSelected}
                />
            </div>
        );
    }
}

export default InvoiceManagement;
